import React from 'react';
import CarrierRecordTable from './CarrierRecordTable/CarrierRecordTable';

const CarrierActiveView = () => <CarrierRecordTable />;

export default CarrierActiveView;
